import { CartItem } from "@/redux/slice/cart/types/CartItem";
import { ServerCartItems } from "@/redux/slice/cart/types/ServerCartItems";

export const getPatientCartItemsFromServer = (serverCartItems: ServerCartItems = []): CartItem[] => {
  const cartItems: CartItem[] = [];

  if (serverCartItems?.length) {
    serverCartItems
      .map(
        ({
          sku,
          magentoId,
          magentoStatus,
          name,
          quantity,
          price,
          sellingPrice,
          mou,
          thumbnail,
          isVCRestricted,
          isPrescriptionRequired,
          subcategory,
          typeId,
          urlKey,
          isInStock,
          maxOrderQty,
          sellOnline,
          isCouponApplicable,
          isShippable,
          cashback,
          freeProduct,
          tatCity,
          tatDuration,
          storeType,
          couponDiscountPrice,
          itemCouponCashback,
          setReminder,
          reminderDuration,
          packForm,
          packSize,
          isVariantAvailable,
          multiVariants,
          moq,
          corporateStatus,
        }) => {
          return {
            url_key: urlKey,
            description: "",
            id: magentoId,
            image: [],
            isVCRestricted,
            is_in_stock: Boolean(isInStock),
            sell_online: Boolean(sellOnline),
            is_prescription_required: isPrescriptionRequired,
            name,
            price,
            sellingPrice,
            sku,
            small_image: thumbnail,
            status: Number(magentoStatus),
            thumbnail,
            type_id: typeId,
            quantity,
            mou,
            isShippable,
            MaxOrderQty: maxOrderQty,
            couponFree: Number(freeProduct),
            subcategory,
            cashback,
            isCouponApplicable,
            tatCity,
            tatDuration,
            storeType,
            couponDiscountPrice,
            itemCouponCashback,
            packForm,
            packSize,
            isReminderSet: setReminder,
            reminderDuration,
            isVariantAvailable,
            multiVariants,
            oosNotified: false,
            moq,
            corporateStatus,
          } as CartItem;
        }
      )
      .forEach((cartItem) => {
        cartItems.push(cartItem);
      });
  }

  return cartItems;
};
